import { Component, inject } from '@angular/core';
import { NzPageHeaderModule } from 'ng-zorro-antd/page-header';
import { NzDescriptionsModule } from 'ng-zorro-antd/descriptions';
import { FileSharingService } from 'src/app/services/file-sharing.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AsyncPipe, DatePipe } from '@angular/common';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { Observable, tap } from 'rxjs';
import { FileSharingDetails } from 'src/app/types/file-sharing.type';
import byteSize from 'byte-size';

@Component({
  selector: 'app-file-sharing-details',
  templateUrl: './file-sharing-details.component.html',
  styleUrls: ['./file-sharing-details.component.scss'],
  standalone: true,
  imports: [
    NzPageHeaderModule,
    NzDescriptionsModule,
    AsyncPipe,
    DatePipe,
    NzTableModule,
    NzDividerModule,
    NzButtonModule,
    NzIconModule,
  ],
})
export class FileSharingDetailsComponent {
  private fileSharingService = inject(FileSharingService);
  private activatedRoute = inject(ActivatedRoute);
  private router = inject(Router);

  id = Number(this.activatedRoute.snapshot.url[1].path);
  activeFileIndex: number | null = null;
  isDownloadingFiles = false;
  pageNumber = this.activatedRoute.snapshot.queryParams['pageNumber'] || 1;
  pageSize = this.activatedRoute.snapshot.queryParams['pageSize'] || 20;
  queryId = this.activatedRoute.snapshot.queryParams['id'] || null;
  queryStartAt = this.activatedRoute.snapshot.queryParams['startAt'] || null;
  queryEndAt = this.activatedRoute.snapshot.queryParams['endAt'] || null;

  fileSharingDetails$: Observable<FileSharingDetails> =
    this.getFileSharingDetails();

  actions$?: Observable<any>;

  getFileSharingDetails(): Observable<FileSharingDetails> {
    return this.fileSharingService.getFileSharingDetails(this.id);
  }

  getByteSize(size: number): string {
    return byteSize(size, { precision: 0 }).toString();
  }

  deleteFile(contentKey: string): void {
    const params = {
      id: this.id,
      contentKey,
    };

    this.actions$ = this.fileSharingService.deleteSharedFile(params).pipe(
      tap(() => {
        this.fileSharingDetails$ = this.getFileSharingDetails();
      }),
    );
  }

  downloadFile(
    fileIndex: number,
    contentKey: string,
    contentName: string,
  ): void {
    const params = {
      id: this.id,
      contentKey,
    };

    this.isDownloadingFiles = true;
    this.activeFileIndex = fileIndex;

    this.actions$ = this.fileSharingService
      .downloadSharedFile(contentName, params)
      .pipe(
        tap(() => {
          this.isDownloadingFiles = false;
          this.activeFileIndex = null;
        }),
      );
  }

  goBack(): void {
    this.router.navigate(['/file-sharing'], {
      queryParams: {
        pageNumber: this.pageNumber,
        pageSize: this.pageSize,
        id: this.queryId,
        startAt: this.queryStartAt,
        endAt: this.queryEndAt,
      },
    });
  }
}
